import React from 'react';
import PropTypes from 'prop-types';

import { useFormContext } from 'react-hook-form';
import { generateStyle } from '../helpers/styles';

/**
* Custom radio element
* 
* @param {Object}          props
* @param {string}          props.label        - The upper label
* @param {string}          props.name         - The component name
* @param {number}          props.width        - Max width inside the container
* @param {Object}          props.options      - Data for component rendering
* @param {Object}          props.validation   - Validation object
* @param {Function}        props.onSelect     - On item select event handler
* @param {(Object|string)} props.defaultValue - Initial value for the input
*/
const RadioInput = ({ label, name, width, options, validation, onSelect, defaultValue }) => {
  const { register, errors, formState } = useFormContext();
  const { key = 'id', text = 'text', value = 'value', data = [] } = options;
  const css = generateStyle('radio', width, formState.touched[name], errors[name]);
  
  const onCheck = (event) => {
    const index = parseInt(event.currentTarget.value);
    const selected = data.find(item => item[key] === index);

    onSelect && onSelect(name, selected);
  }
  return (
    <div className={css}>
      {
        label && <p className='radio__label'>
          {label}
        </p>
      }
      <div className='radio__container'>
        {
          data && data.map(item => {
            return <label key={item[key]} className='radio__item'>
              <input
                className='radio__checkbox'
                type='radio'
                name={name}
                value={item[key]}
                checked={item[key] == defaultValue?.id}
                onChange={onCheck}
                ref={register(validation)}
              />
              <span className='radio__element'>
                {item[text]}
              </span>
            </label>
          })
        }
      </div>
      {errors[name] && <span className='radio__error'>{errors[name].message}</span>}
    </div>
  );
}
RadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  options : PropTypes.object.isRequired,
  label: PropTypes.string,
  width: PropTypes.number,
  onSelect: PropTypes.func,
  validation: PropTypes.object,
  defaultValue: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
};
export default RadioInput;